// Lightweight debug logger for this workspace, test-friendly
export const debugLog = (...args: any[]): void => {
  if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') {
    try {
      // Use console.debug to make it easy to filter
      // eslint-disable-next-line no-console
      console.debug(...args);
    } catch (_) {
      // no-op
    }
  }
};


